import { RestrictionErrorCode, RestrictionErrorMinimal, RestrictionNoPartyError } from 'libs/domain';
import { restriction_pb } from 'libs/generated-grpc-ts';

export const toProto = (error: RestrictionErrorMinimal): restriction_pb.RestrictionError => {
  const message = new restriction_pb.RestrictionError();
  if (error.code) message.setCode(error.code);
  if (error.personHash) message.setPersonHash(error.personHash);
  if (error.personName) message.setPersonName(error.personName);
  if (error.message) message.setMessage(error.message);
  for (const errorNoPartyInfo of error.noPartyInfos || []) {
    const noPartyInfo = new restriction_pb.RestrictionNoPartyError();
    noPartyInfo.setNoPartyName(errorNoPartyInfo.partyName);
    noPartyInfo.setConflictPersonNameList(errorNoPartyInfo.conflictPersonNames);
    message.addNoPartyInfo(noPartyInfo);
  }
  return message;
};

export const fromProto = (message: restriction_pb.RestrictionError): RestrictionErrorMinimal => {
  let noPartyInfos: RestrictionNoPartyError[] | undefined;
  const partyInfos = message.getNoPartyInfoList();
  if (partyInfos.length) {
    noPartyInfos = partyInfos.map(partyInfo => ({
      partyName: partyInfo.getNoPartyName(),
      conflictPersonNames: partyInfo.getConflictPersonNameList(),
    }));
  }
  return {
    code: message.getCode() as RestrictionErrorCode,
    personHash: message.getPersonHash(),
    personName: message.getPersonName(),
    message: message.getMessage(),
    noPartyInfos,
  };
};
